// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boton-social-fb {
  background-color: #39599a;
  color: white;
  text-align: center;
  vertical-align: middle;
}

mat-card.movil {
  margin: 0 !important;
  padding: 4px !important;
}

.contenedor {
  height: auto !important;
  min-height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

.contenedor.bg-1 {
  background: url('fondo_registro.798fb988c3ea5403.jpg') no-repeat center center fixed !important;
  background-size: cover !important;
}`, "",{"version":3,"sources":["webpack://./src/app/auth/login/registro/registro.component.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AACD;;AAEA;EACC,oBAAA;EACA,uBAAA;AACD;;AACA;EACC,uBAAA;EACA,2BAAA;EACA,oBAAA;EACA,qBAAA;AAED;;AACA;EACI,+FAAA;EAIH,iCAAA;AAED","sourcesContent":[".boton-social-fb{\r\n\tbackground-color: #39599a;\r\n\tcolor: white;\r\n\ttext-align: center;\r\n\tvertical-align: middle;\r\n}\r\n\r\nmat-card.movil{\r\n\tmargin:0!important;\r\n\tpadding: 4px!important;\r\n}\r\n.contenedor {\r\n\theight: auto  !important;\r\n\tmin-height: 100% !important;\r\n\tmargin: 0 !important;\r\n\tpadding: 0  !important;\r\n}\r\n\r\n.contenedor.bg-1 {\r\n    background: url(\"../../../../assets/login/images/auth/fondo_registro.jpg\") no-repeat center center fixed !important;\r\n\t-webkit-background-size: cover!important;\r\n\t-moz-background-size: cover!important;\r\n\t-o-background-size: cover!important;\r\n\tbackground-size: cover!important;\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
